module.exports = __webpack_public_path__ + "13bf3a532036568ec29afb920eaeb92b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/GC_PUBLIKUM.jpg
// module id = 476
// module chunks = 0